import { useTranslation } from "react-i18next";
import { usePageTitle } from "@/hooks/usePageTitle";
import { ProjectKPITable } from "./project-kpi-table";
import { useParams } from "react-router-dom";
import type { projectIdKey } from "@/routes/company/routes.projects.constants";
import { withBranding } from "@/utils/helper";

export const TabProjectKPIs = () => {
  const { t } = useTranslation(["projects", "common"]);
  const { projectId } = useParams<{ [projectIdKey]: string }>();
  usePageTitle(withBranding(t("projects:project_kpis")));

  if (!projectId) return t("projects:project_id_not_found");
  return <ProjectKPITable projectId={projectId} />;
};
